import React from 'react';
import PropTypes from 'prop-types';
import { formatUtc } from '../UtcDate';

function DateTime(props) {
  let s = '';
  let timeStamp = props.ts;

  if (timeStamp > 0) {
    if (timeStamp < 9999999999) {
      timeStamp *= 1000;
    }
    if (timeStamp % 1000 === 0) {
      s = formatUtc(timeStamp, 'YYYY-MM-DD HH:mm:ss');
    } else {
      s = formatUtc(timeStamp, 'YYYY-MM-DD HH:mm:ss.SSS');
    }
  }

  return (
    <span className="datetime">{s}</span>
  );
}

DateTime.propTypes = {
  ts: PropTypes.number
};

export default DateTime;



// WEBPACK FOOTER //
// ./src/js/Component/DateTime.jsx